import { sortArrayBy } from '@domain-group/javascript-utils'

function mapContactsAndUserObjects(contacts, users, images){
  const contactArray = Object.keys(contacts).map((key) => {
    const contact = contacts[key]
    return {
      email: contact.email,
      entity_id: contact.id,
      entity_type: 'Contact',
      first_name: contact.first_name,
      full_name: contact.full_name,
      last_name: contact.last_name,
      mobile: contact.mobile,
      type: 'Contact',
    }
  })

  const userArray = Object.keys(users)
    .map((key) => {
      const user = users[key]
      const image = images[user.image]
      const actable = user.actable || {}

      const object = {
        email: user.email,
        entity_id: actable.id,
        entity_type: actable.type,
        first_name: user.first_name,
        full_name: user.full_name,
        id: user.id,
        last_name: user.last_name,
        mobile: user.mobile_number || actable.mobile,
        type: actable.type,
      }

      if (image){
        object.image = {
          square: image.thumb_url || null,
        }
      }

      return object
    })

  const merged = userArray.concat(contactArray)

  return sortArrayBy(merged, 'asc', 'full_name')
}

export default mapContactsAndUserObjects
